import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SwiperClass } from 'swiper/react'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import classes from './styles.module.scss'

interface NavigationProps {
  swiper: SwiperClass
  navigationStyle?: React.CSSProperties
}

interface ButtonProps {
  direction: 'prev' | 'next'
  onClick: () => void
  icon: any
  disabled: boolean
  navigationStyle?: React.CSSProperties
}

export const NavigationTabs: React.FC<NavigationProps> = ({
  swiper,
  navigationStyle = {}
}) => {
  // Track current state of the swiper
  const [swiperState, setSwiperState] = useState({
    isBeginning: true,
    isEnd: false
  })

  // Update swiper state on slide change and fetch more slides if nearing the end
  useEffect(() => {
    if (!swiper) return

    const onSlideChange = (s: SwiperClass) => {
      setSwiperState({
        isBeginning: s.isBeginning,
        isEnd: s.isEnd
      })
    }

    swiper.on('slideChange', onSlideChange)
    return () => {
      swiper.off('slideChange', onSlideChange)
    }
  }, [swiper])

  // Handlers for navigating slides
  const handlePrevPage = () => {
    swiper.slidePrev()
  }

  const handleNextPage = () => {
    swiper.slideNext()
  }

  return (
    <div className={classes.navigationContainer}>
      <NavigationButton
        direction="prev"
        icon={faChevronLeft}
        onClick={handlePrevPage}
        disabled={swiperState.isBeginning}
        navigationStyle={navigationStyle}
      />
      <NavigationButton
        direction="next"
        icon={faChevronRight}
        onClick={handleNextPage}
        disabled={swiperState.isEnd}
        navigationStyle={navigationStyle}
      />
    </div>
  )
}

const NavigationButton: React.FC<ButtonProps> = ({
  direction,
  onClick,
  icon,
  disabled,
  navigationStyle = {}
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'navigation__button',
        classes.button,
        {
          [classes['button--disabled']]: disabled,
          [classes[`button__${direction}`]]: true,
        }
      )}
      style={navigationStyle}
    >
      <FontAwesomeIcon icon={icon} />
    </div>
  )
}